module.exports = __webpack_public_path__ + "img/med4.4ff2394.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/med4.png
// module id = dIC1
// module chunks = 0